import React from "react";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { setSessionToken } from "Skelet/src/modules/fetch.action.js";
import { toggleDropdown } from "Skelet/src/modules/functions.js";
import logo from "../../images/logo-dieetclub.png";

class CoreRouteHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = { dropdown_open: false };

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ dropdown_open: false });
    }
  }

  render() {
    return (
      <header>
        <div className="container">
          <div className="primary">
            <Link
              to="/"
              onClick={() =>
                document.getElementById("main").scrollIntoView(true)
              }
              className="logo"
            >
              <img src={logo} alt={this.props.config.app_id} />
            </Link>
          </div>
          <div className="secondary">
            <nav className="navigation">
              <ol>
                {/*<li className={"nav-item" + ((this.props.pathname === "/todo") ? " current" : "")}><Link to="/todo">Gewoontes</Link></li>*/}
                {this.props.is_admin && (
                  <li
                    className={
                      "md-shown nav-item" +
                      (this.props.pathname === "/beheer-gebruikers"
                        ? " current"
                        : "")
                    }
                  >
                    <Link to="/beheer-gebruikers" className="btn">
                      <i>Beheer Gebruikers</i>
                    </Link>
                  </li>
                )}
                <li
                  className={
                    "md-shown nav-item" +
                    (this.props.pathname === "/dagboek" ? " current" : "")
                  }
                >
                  <Link to="/dagboek" className="btn">
                    Dagboek
                  </Link>
                </li>
                <li
                  className={
                    "md-shown nav-item" +
                    (this.props.pathname === "/lichaam" ? " current" : "")
                  }
                >
                  <Link to="/lichaam" className="btn">
                    Lichaam
                  </Link>
                </li>
                <li
                  className={
                    "md-shown nav-item" +
                    (this.props.pathname === "/" ? " current" : "")
                  }
                >
                  <Link to="/" className="btn">
                    Persoonlijk
                  </Link>
                </li>
                <li
                  className={
                    "nav-item dropdown" +
                    (this.state.dropdown_open ? " open" : "")
                  }
                  ref={this.setWrapperRef}
                >
                  <Link
                    to="/instellingen"
                    onClick={(e) => toggleDropdown(this, e)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      style={{ height: "32px" }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 6h16M4 12h16M4 18h16"
                      />
                    </svg>
                  </Link>
                  <div className="dropdown-menu">
                    <div className="dropdown-caret">
                      <span className="caret-outer"></span>
                      <span className="caret-inner"></span>
                    </div>
                    <ul>
                      <li
                        className={
                          "sub-item highlight" +
                          (this.props.pathname === "/instellingen"
                            ? " current"
                            : "")
                        }
                      >
                        <Link
                          to="/instellingen"
                          onClick={() => toggleDropdown(this)}
                        >
                          <b>{this.props.account_data.firstname}</b>
                          <p>Instellingen</p>
                        </Link>
                      </li>
                      <li
                        className={
                          "sub-item" +
                          (this.props.pathname === "/profiel" ? " current" : "")
                        }
                        onClick={() => toggleDropdown(this)}
                      >
                        <Link to="/profiel">Profiel</Link>
                      </li>
                      <li className="md-hidden dropdown-divider"></li>
                      <li
                        className={
                          "md-hidden sub-item" +
                          (this.props.pathname === "/" ? " current" : "")
                        }
                        onClick={() => toggleDropdown(this)}
                      >
                        <Link to="/">Persoonlijk</Link>
                      </li>
                      <li
                        className={
                          "md-hidden sub-item" +
                          (this.props.pathname === "/lichaam" ? " current" : "")
                        }
                        onClick={() => toggleDropdown(this)}
                      >
                        <Link to="/lichaam">Lichaam</Link>
                      </li>
                      <li
                        className={
                          "md-hidden sub-item" +
                          (this.props.pathname === "/dagboek" ? " current" : "")
                        }
                      >
                        <Link
                          to="/dagboek"
                          onClick={() => toggleDropdown(this)}
                        >
                          Dagboek
                        </Link>
                      </li>
                      <li className="dropdown-divider"></li>
                      {this.props.is_admin && (
                        <li
                          className={
                            "md-hidden sub-item" +
                            (this.props.pathname === "/beheer-gebruikers"
                              ? " current"
                              : "")
                          }
                          onClick={() => toggleDropdown(this)}
                        >
                          <Link to="/beheer-gebruikers">
                            <i>Beheer Gebruikers</i>
                          </Link>
                        </li>
                      )}
                      {this.props.is_admin && (
                        <li className="md-hidden dropdown-divider"></li>
                      )}
                      <li className="sub-item">
                        <Link
                          to="/start"
                          target="_blank"
                          onClick={() => toggleDropdown(this)}
                        >
                          Start
                        </Link>
                      </li>
                      <li className="dropdown-divider"></li>
                      <li className="sub-item">
                        <Link to="/" onClick={this.props.logOut}>
                          Uitloggen
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </header>
    );
  }
}

function mapStateToProps(state) {
  let account_data = null;
  if (
    state.apiData["login"] !== undefined &&
    state.apiData["login"]["data"]["token"] !== undefined
  ) {
    account_data = state.apiData["login"]["data"];
  }
  return {
    account_data: account_data,
    is_admin: account_data.email === "hi@peter.plus" ? true : false,
    pathname: state.router.location.pathname,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logOut: () => {
        document.getElementById("main").scrollIntoView(true);
        return setSessionToken(null);
      },
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CoreRouteHeader);



// WEBPACK FOOTER //
// ./src/containers/route-containers/CoreRouteHeader.js